import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Key, RefreshCw, LogOut } from 'lucide-react';
import ChangePasswordPanel from './ChangePasswordPanel';

export default function AdminHeader({ loading, onRefresh, onLogout }) {
  const [showChangePwd, setShowChangePwd] = useState(false);
  return (
    <>
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 mb-6">
        <div>
          <Link to="/" className="inline-flex items-center gap-1 text-earth/50 hover:text-saffron text-sm font-sans mb-2 transition-colors" data-testid="back-to-website">
            <ArrowLeft size={14} /> Back to Website
          </Link>
          <h1 className="font-display text-3xl font-bold text-earth-dark tracking-tight">Admin Dashboard</h1>
        </div>
        <div className="flex flex-wrap items-center gap-2">
          <button onClick={() => setShowChangePwd(s => !s)} className="flex items-center gap-1.5 bg-white border border-earth/15 text-earth/60 font-sans text-xs px-3 py-2 rounded-md hover:bg-saffron/5 transition-colors" data-testid="change-pwd-btn">
            <Key size={12} /> Change Password
          </button>
          <button onClick={onRefresh} className="flex items-center gap-2 bg-white border border-earth/15 text-earth-dark font-sans text-sm px-4 py-2.5 rounded-md hover:bg-saffron/5 transition-colors" data-testid="refresh-button">
            <RefreshCw size={14} className={loading ? 'animate-spin' : ''} /> Refresh
          </button>
          <button onClick={onLogout} className="flex items-center gap-1.5 bg-chilli/10 border border-chilli/20 text-chilli font-sans text-xs px-3 py-2 rounded-md hover:bg-chilli/20 transition-colors" data-testid="logout-btn">
            <LogOut size={12} /> Logout
          </button>
        </div>
      </div>
      {showChangePwd && <ChangePasswordPanel onDone={() => setShowChangePwd(false)} />}
    </>
  );
}
